import { Box } from '@mui/joy';

/**
 * Контентная колонка экрана.
 *
 * Зачем: на ПК контент был прижат к левому краю, а справа оставалось полэкрана
 * пустоты — у экранов не было ни максимальной ширины, ни центрирования.
 * Теперь один компонент задаёт поля и ширину колонки для всех разделов сразу,
 * и отступ снизу под нижнее меню телефона.
 *
 *   width="narrow" — 760px (списки в одну колонку, чтение)
 *   width="normal" — 1080px (по умолчанию)
 *   width="wide"   — 1320px (плотные сетки)
 */
export default function PageContainer({
    children,
    width = 'normal',
    bottomGap = true,
    className = '',
    sx,
    ...props
}) {
    const mod = width === 'narrow' ? ' lvc-page--narrow' : width === 'wide' ? ' lvc-page--wide' : '';

    return (
        <Box
            className={`lvc-page${mod}${className ? ` ${className}` : ''}`}
            sx={{
                pt: { xs: 2, sm: 2.5 },
                pb: bottomGap ? { xs: 3, md: 4 } : 0,
                ...sx,
            }}
            {...props}
        >
            {children}
        </Box>
    );
}
